export default function HomeAboutSection() {
  const stats = [
    { value: '5000+', label: '总漫画数' },
    { value: '1000万+', label: '累计读者' },
    { value: '98%', label: '好评率' },
    { value: '24h', label: '更新频率' },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 md:gap-16">
          <div className="lg:w-1/2">
            <span className="text-xs font-medium text-foreground-500 tracking-widest">
              关于178漫画网
            </span>
            <div className="mt-8 max-w-lg">
              <p className="text-lg md:text-xl text-foreground-800 leading-relaxed">
                178漫画网致力于为广大漫画爱好者提供<strong>高清漫画全集免费阅读</strong>服务。平台汇聚了海量正版授权漫画资源，涵盖<strong>治愈、热血、恋爱、悬疑</strong>等多种类型，满足不同读者的阅读需求。
              </p>
              <p className="text-lg md:text-xl text-foreground-800 leading-relaxed mt-4">
                我们采用<strong>下拉式阅读</strong>体验，搭配<strong>超清画质</strong>，让每一位读者都能享受到极致的<strong>视觉盛宴</strong>。无论你是追更党还是补番族，178漫画网都是你的最佳选择。
              </p>
            </div>
          </div>

          <div className="lg:w-1/2">
            <div className="grid grid-cols-2 gap-6 md:gap-8">
              {stats.map((stat) => (
                <div
                  key={stat.label}
                  className="text-center p-6 md:p-8 rounded-2xl bg-background-50"
                >
                  <span className="font-heading text-3xl md:text-5xl font-black text-foreground-900">
                    {stat.value}
                  </span>
                  <p className="text-sm text-foreground-500 mt-2 font-medium">
                    {stat.label}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}